import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useShipmentSummariesCommonStyles = createStyles(
  ({ css, cx, token }) => {
    const sectionHeader = cx(
      css({
        height: 25,
        lineHeight: '24px',
        backgroundColor: ThemeColors.COLOR_GREY9_8,
        paddingLeft: ThemeSpaces.SPACE_NORM,
        borderTop: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        fontWeight: 'bold',
        marginTop: ThemeSpaces.SPACE_NORM,
      })
    );
    const sectionBody = cx(
      css({
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
      })
    );
    const deviceAddonRowIndex = cx(
      css({
        height: 18,
        width: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '100%',
        backgroundColor: ThemeColors.COLOR_RED,
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
        fontWeight: 'bold',
        color: token.colorWhite,
        marginRight: ThemeSpaces.SPACE_MD,
      })
    );

    return {
      sectionHeader,
      sectionBody,
      section: {
        overflow: 'hidden',
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,

        [`@media (min-width: ${token.screenMDMin}px) and (max-width: ${token.screenMDMax}px)`]:
          {
            '.label': {
              width: '36%',
            },
          },
        '&.collapsible': {
          [`.${sectionHeader}`]: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          },
          '.fa-caret-down, .fa-caret-up': {
            width: 20,
          },
        },
      },
      sectionSpecialInstructions: {
        '&&': {
          padding: 0,
        },

        [`.${sectionHeader}`]: {
          backgroundColor: ThemeColors.COLOR_WHITE6,
          color: ThemeColors.COLOR_GREY_BLUISH2,
          fontSize: token.fontSizeSM,
          fontWeight: 'normal',
          textTransform: 'uppercase',
        },
      },
      specialInstructionsParagraph: {
        '&&': {
          marginBottom: 0,
          fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
        },
      },
      sectionCharges: {
        '&&': {
          padding: 0,
        },

        [`.${sectionHeader}`]: {
          backgroundColor: ThemeColors.COLOR_WHITE6,
          color: ThemeColors.COLOR_GREY_BLUISH2,
          fontSize: token.fontSizeSM,
          fontWeight: 'normal',
          textTransform: 'uppercase',
        },
        [`.${sectionBody}`]: {
          padding: '4px 10px',
        },
      },
      chargesItem: {
        '&&&': {
          padding: 0,
          fontSize: token.fontSizeSM,

          '&:last-child': {
            fontWeight: 600,
          },
        },
      },
      deviceAddonRow: {
        '.IconButton': {
          color: ThemeColors.COLOR_RED,
          position: 'absolute',
          top: '50%',
          right: 11, // To be aligned with assets inventory icon
          transform: 'translateY(-50%)',
        },
      },
      deviceAddonRowHeader: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        height: 22,
        backgroundColor: ThemeColors.COLOR_WHITE6,
        border: `1px solid ${ThemeColors.COLOR_GREY9_5}`,
        padding: `0 ${ThemeSpaces.SPACE_NORM}px`,

        '&.active': {
          backgroundColor: ThemeColors.COLOR_RED,
          color: token.colorWhite,

          '.IconButton': {
            color: token.colorWhite,
          },
          [`.${deviceAddonRowIndex}`]: {
            backgroundColor: token.colorWhite,
            color: ThemeColors.COLOR_RED,
          },
        },
      },
      deviceAddonRowIndex,
      deviceAddonRowHeaderLabel: {
        fontSize: ThemeFont.FONT_SIZE_XS,
        textTransform: 'uppercase',
        marginRight: ThemeSpaces.SPACE_XS,
      },
      deviceAddonRowHeaderValue: {
        fontFamily: ThemeFont.FONT_CONDENSED,
        fontSize: token.fontSizeSM,
        fontWeight: 'bold',
      },
      deviceAddonLabelRow: {
        padding: `${ThemeSpaces.SPACE_NORM}px 0`,
      },
      deviceAddonLabelRowLast: {
        '&&': {
          paddingBottom: 0,
        },
      },
    };
  }
);
